import { PLUS_CHAR } from '@common/constants';

export const formatBalanceSum = (sum: number) => {
  const formattedSum = (sum ?? 0).toLocaleString('ru-RU');
  return sum > 0 ? `${PLUS_CHAR}${formattedSum}` : formattedSum;
};

